import * as React from 'react';
import { connect } from 'react-redux';
import { Text } from 'wix-ui-tpa/Text';
import { useTranslation } from 'react-i18next';
import * as statsUtils from './StatsUtils/StatsUtils';

import { st, classes } from './Stats.st.css';

const CountProfileData = ({
  count,
  isEnd,
  isDisplay,
  isMobile,
  translationKey,
  isRtl,
}) => {
  const { t } = useTranslation();
  if (!isDisplay) {
    return null;
  }
  const title = t(translationKey);
  const countToDisplay = statsUtils.formatCount(count);
  const profileData = isRtl
    ? `${title} ${countToDisplay}`
    : `${countToDisplay} ${title}`;
  return (
    <>
      <Text className={st(classes.ProfilePosts, { isEnd, isMobile })}>
        {profileData}
      </Text>
    </>
  );
};

const Stats = ({
  isMobile,
  user,
  isDisplayPostsCount,
  isDisplayFollowersCount,
  isDisplayFollowingCount,
  m_isDisplayPostsCount,
  m_isDisplayFollowersCount,
  m_isDisplayFollowingCount,
  isHeaderLayoutCenter,
  m_isHeaderLayoutCenter,
  isRtl,
}) => {
  const isCenter = isMobile ? m_isHeaderLayoutCenter : isHeaderLayoutCenter;

  if (
    !isMobile &&
    !isDisplayPostsCount &&
    !isDisplayFollowersCount &&
    !isDisplayFollowingCount
  ) {
    return null;
  }

  if (
    isMobile &&
    !m_isDisplayPostsCount &&
    !m_isDisplayFollowersCount &&
    !m_isDisplayFollowingCount
  ) {
    return null;
  }

  return (
    <div
      style={{ maxHeight: `36px` }}
      className={st(classes.WarpStats, { isHeaderLayoutCenter: isCenter })}
    >
      <CountProfileData
        isMobile={isMobile}
        count={user.media_count || 0}
        translationKey="widget.header.posts"
        isDisplay={isMobile ? m_isDisplayPostsCount : isDisplayPostsCount}
        isRtl={isRtl}
      />
      <CountProfileData
        isMobile={isMobile}
        count={user.followers_count || 0}
        translationKey="widget.header.followers"
        isDisplay={
          isMobile ? m_isDisplayFollowersCount : isDisplayFollowersCount
        }
        isRtl={isRtl}
      />
      <CountProfileData
        isMobile={isMobile}
        count={user.follows_count || 0}
        translationKey="widget.header.following"
        isEnd={true}
        isDisplay={
          isMobile ? m_isDisplayFollowingCount : isDisplayFollowingCount
        }
        isRtl={isRtl}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isMobile: state.appReducer.isMobile,
  user: state.appReducer.user,
  isDisplayPostsCount: state.settingsReducer.isDisplayPostsCount,
  isDisplayFollowersCount: state.settingsReducer.isDisplayFollowersCount,
  isDisplayFollowingCount: state.settingsReducer.isDisplayFollowingCount,
  m_isDisplayPostsCount: state.settingsReducer.m_isDisplayPostsCount,
  m_isDisplayFollowersCount: state.settingsReducer.m_isDisplayFollowersCount,
  m_isDisplayFollowingCount: state.settingsReducer.m_isDisplayFollowingCount,
  isHeaderLayoutCenter: state.settingsReducer.isHeaderLayoutCenter,
  m_isHeaderLayoutCenter: state.settingsReducer.m_isHeaderLayoutCenter,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Stats);
